module.exports = __webpack_public_path__ + "img/Marca1.caed807e.jpg";